<template>
    <div class="c-outages-messages">
        <div class="c-outages-messages__message"
            :class="{ 'c-outages-messages__message--show': active }"
            v-for="message in cmsContent.toastMessage">
            <img class="c-outages-messages__message-icon" :src="message.MessageIcon" width="45" height="45" />
            <div class="c-outages-messages__message-text" v-html="message.MessageText"></div>

            <div class="c-outages-messages__message-close" @click="hideMessage"></div>
        </div>

        <!-- <div class="c-outages-messages__cookies" @click="clearCookies">Clear Cookies - testing only</div> -->
    </div>
</template>
  
<script>
    import { mapFields } from "vuex-map-fields";
    
    export default {
        data() {
            return {
                active: false,
            };
        },
        async mounted() {
            // wait until the map has loaded
            await this.$gmapApiPromiseLazy().
            then(() => {                
                if (document.cookie && document.cookie.includes('hideMessage=true')) {
                    console.log('cookie set');
                    this.active = false;
                } else {
                    console.log('no cookies set');
                    this.active = true;                    
                }                    
            });
        },
        computed: {
            ...mapFields(["cmsContent"]),
        },
        methods: {
            hideMessage() {
                this.active = false;
                // set cookie to hide message for 24 hours
                const date = new Date();
                date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
                document.cookie = `hideMessage=true; expires=${date.toUTCString()}; path=/`;
            },
            clearCookies() {
                document.cookie = '';
            }
        },
    };
</script>
  
<style lang="scss"></style>  